import { withTheme } from 'styled-components';
import * as d3 from 'd3';
import { useEffect, useRef } from 'react';
import { getColor } from 'utils';

const BarGraph = withTheme(props => {
    const { data } = props;
    const color = getColor(props, 'accent');
    const ref = useRef();

    const width = props?.width ?? 928;
    const height = props?.height ?? 250;
    const marginTop = props?.marginTop ?? 30;
    const marginRight = props?.marginRight ?? 0;
    const marginBottom = props?.marginBottom ?? 30;
    const marginLeft = props?.marginLeft ?? 40;

    useEffect(() => {
        const x = d3.scaleBand()
            .domain(data.map(d => `${d.month} ${d.year}`))
            .range([ marginLeft, width - marginRight ])
            .padding(0.1);

        const y = d3.scaleLinear()
            .domain([ 0, d3.max(data, d => d.count) ]).nice()
            .range([ height - marginBottom, marginTop ]);

        const svgElement = d3.select(ref.current)
            .attr('width', width)
            .attr('height', height)
            .attr('viewBox', [ 0, 0, width, height ])
            .attr('style', 'max-width: 100%; height: auto;');

        // Bar Elements
        svgElement.append('g')
            .attr('fill', color)
            .selectAll()
            .data(data)
            .join('rect')
            .attr('x', d => x(`${d.month} ${d.year}`))
            .attr('y', d => y(d.count))
            .attr('height', d => y(0) - y(d.count))
            .attr('width', x.bandwidth());

        // Horizontal Axis
        svgElement.append('g')
            .attr('transform', `translate(0,${height - marginBottom})`)
            .call(d3.axisBottom(x).tickSizeOuter(0));

        // Vertical Axis
        svgElement.append('g')
            .attr('transform', `translate(${marginLeft},0)`)
            .call(d3.axisLeft(y).tickFormat(y => (y).toFixed()))
            .call(g => g.select('.domain').remove())
            .call(g => g.append('text')
            .attr('x', -marginLeft)
            .attr('y', 10)
            .attr('fill', 'currentColor')
            .attr('text-anchor', 'start')
            .text('↑ Count'));
    }, []);

    return (
        <svg ref={ref} />
    );
});

export { BarGraph };